<template>
  <transition
    enter-active-class="transform ease-out duration-300 transition"
    enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
    leave-active-class="transition ease-in duration-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-if="show" class="fixed z-[9999] top-4 right-4 max-w-sm w-full bg-card shadow-lg rounded-lg pointer-events-auto ring-1 ring-border overflow-hidden">
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <i
              :class="[
                type === 'success' ? 'fas fa-check-circle text-green-600 dark:text-green-400' :
                type === 'error' ? 'fas fa-exclamation-circle text-red-600 dark:text-red-400' :
                type === 'info' ? 'fas fa-info-circle text-blue-600 dark:text-blue-400' :
                'fas fa-exclamation-circle text-yellow-600 dark:text-yellow-400',
                'text-xl'
              ]"
            ></i>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium text-foreground">{{ title }}</p>
            <p class="mt-1 text-sm text-muted-foreground">{{ message }}</p>
            <button
              v-if="actionLabel"
              @click="$emit('action')"
              class="mt-2 text-sm font-semibold text-primary hover:underline focus:outline-none"
            >
              {{ actionLabel }}
            </button>
          </div>
          <div class="ml-4 flex-shrink-0 flex">
            <button
              @click="$emit('close')"
              class="bg-card rounded-md inline-flex text-muted-foreground hover:text-foreground focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
            >
              <span class="sr-only">Close</span>
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ToastNotification',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      default: 'success',
      validator: value => ['success', 'error', 'info', 'warning'].includes(value)
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    actionLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['close', 'action']
}
</script> 